import { make } from 'redux-chill';

import type { ReceiverInfoUt } from '../types';

const setDeliveryReceiverInfoUt = make('[delivery] set receiverUt info')
  .stage((info: ReceiverInfoUt) => ({ info }))
  .stage('reset');

export { setDeliveryReceiverInfoUt };
